import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { LayoutDualMode } from '.';
import { horizontalModeList, layoutList, layoutType, videoLayoutMode } from '../constants';
import { getCurrentMode } from '../functions';
import { LayoutContainerStyled } from '../styled';
import GridMode from './GridMode';
import MobileMode from './MobileMode';
import PresentHorizontalMode from './PresentHorizontalMode';
import PresentVerticalMode from './PresentVerticalMode';
import { getScreenType } from '../../base/util';
import { isChatOpen } from '../../chat';
import { debounce } from 'lodash';

function LayoutContainer({ 
    userAgentType, mode,
    roomCode, isDualMonitor, resize    
}) {
    const layout = useRef();
    const [screenType, setScreenType ] = useState(layoutType.desktop);
    const rightOpen = useSelector(state => {
        const isChat = isChatOpen(state);
        const {isOpen: isParticipant} = state["features/participant-right"];

        return isChat || isParticipant;
    })

    useEffect(() => {
        const type = getScreenType(layout.current?.clientWidth);
        setScreenType(type);
    }, [rightOpen, resize]);

    const renderContent = () => {
        // 듀얼 모니터
        if (isDualMonitor) {
            return <LayoutDualMode mode={mode} roomCode={roomCode} />
        }

        // 모바일
        if ( screenType === layoutType.mobile || userAgentType === layoutType.mobile ||
            (userAgentType === layoutType.tablet && layoutList.indexOf(mode) !== -1) 
        ) {
            return <MobileMode type={screenType} resize={resize} userAgentType={userAgentType} 
                mode={mode} roomCode={roomCode} 
            />
        }

        // 화면 타입에 따른 모드
        switch (mode) {
            case videoLayoutMode.document:
            case videoLayoutMode.pin:
            case videoLayoutMode.seminar:
            case videoLayoutMode.white:
            case videoLayoutMode.note:
            case videoLayoutMode.voice:
            case videoLayoutMode.vod:
                return (
                    <PresentHorizontalMode
                        mode={mode}
                        type={screenType}
                        roomCode={roomCode}
                        resize={resize} 
                    />
                );

            case videoLayoutMode.screen:
                return (
                    <PresentVerticalMode
                        mode={mode}
                        type={screenType}
                        roomCode={roomCode}
                    />
                );

            default:
                return (
                    <GridMode type={screenType} />
                );
        }
    };

    const isDocument = horizontalModeList.indexOf(mode) !== -1 ? true : false;
    const isGrid = layoutList.indexOf(mode) !== -1 ? true : false;

    return (
        <LayoutContainerStyled ref={layout} className="layout_wrapper" isDocument={isDocument} isGrid={isGrid}>
            { renderContent() }
        </LayoutContainerStyled>
    );
}

function _mapStateToProps(state) {
    const mode = getCurrentMode(state);
    const { isDualMonitor } = state['features/video-layout-mode'];

    return {
        mode,
        isDualMonitor
    };
}

export default connect(_mapStateToProps)(LayoutContainer);
